import { Fragment, useState } from "@wordpress/element";
import  { Toolbar, ToolbarButton, Popover } from "@wordpress/components";
import  { RichText, MediaUpload, BlockControls, URLInput } from "@wordpress/block-editor";
import { __ } from "@wordpress/i18n";
const ALLOWED_MEDIA_TYPES = [ 'image' ];

const Testimonial = {
  title: __('Testimonial'),
  description: __('Testimonial block for the ABS theme'),
  icon: 'admin-comments',
  supports: {
    customClassName: false,
  },
  attributes: {
    testimonial: {
      type: 'string',
    },
    author: {
      type: 'string',
    },
    imgUrl: {
      type: 'string',
      default: 'https://dummyimage.com/1920x720/cadae2/49585f.png&text=Placeholder'
    },
    imgAlt: {
      type: 'string'
    },
    href: {
      type: 'string'
    },
    hrefTitle: {
      type: 'string'
    }
  },
  edit({ className, attributes, setAttributes }) {
    const { testimonial, imgUrl, imgAlt, href, author } = attributes;

    const linkPopover = () => {
      const [ isVisible, setIsVisible ] = useState( false );
      const toggleVisible = () => {
        setIsVisible( ( state ) => ! state );
      };

      return (
        <ToolbarButton
          icon={ 'admin-links' }
          label="Link"
          onClick={ toggleVisible }>
          { isVisible &&
            <Popover>
              <URLInput
                className={ className }
                value={ href }
                onChange={ ( url ) => setAttributes( { href: url } ) }
              />
            </Popover> }
        </ToolbarButton>
      );
    };

    const image = (
      <img
        src={ imgUrl }
        alt={ imgAlt }
      />
    );

    function selectImage(value) {
      setAttributes({
        imgUrl: value.media_details.sizes.full_width.source_url,
        imgAlt: value.alt_text,
      })
    }

    return (
      <Fragment>
        <div className={ className }>
          <div className={"container-fluid"}>
            <div className={"row"}>
              <div className={"col-12 image"}>
                { image }
              </div>
              <div className={"col-12 testimonial"}>
                <blockquote>
                <RichText
                  identifier="testimonial"
                  tagName="p"
                  value={testimonial}
                  placeholder={__('Insert testimonial')}
                  multiline={true}
                  allowedFormats={[]}
                  onChange={nextTestimonial => {
                    setAttributes({
                      testimonial: nextTestimonial,
                    });
                  }}
                />
                <RichText
                  identifier="author"
                  tagName="p"
                  className={'author'}
                  value={author}
                  placeholder={__('Insert author')}
                  multiline={false}
                  allowedFormats={[]}
                  onChange={nextAuthor => {
                    setAttributes({
                      author: nextAuthor,
                    });
                  }}
                />
                </blockquote>
              </div>
            </div>
          </div>
        </div>
        <BlockControls>
          <Toolbar>
            { linkPopover() }
            <MediaUpload
              allowedTypes={ ALLOWED_MEDIA_TYPES }
              onSelect={ selectImage }
              render={ ({open}) => {
                return (
                  <ToolbarButton
                    icon={ 'format-image' }
                    label={ __('Set image') }
                    onClick={ open } />)
              }}
            />
          </Toolbar>
        </BlockControls>
      </Fragment>
    );
  },

  save({ className, attributes }) {
    const { testimonial, imgUrl, imgAlt, href, author } = attributes;

    const image = (
      <div className={"col-12 px-0 image"}>
        <img
          src={ imgUrl }
          alt={ imgAlt }
          className={ 'img-fluid' }
        />
      </div>
    );

    const text = (
      <div className={"col-12 testimonial"}>
        <blockquote>
      { ! RichText.isEmpty( testimonial ) && (
        <RichText.Content tagName="p" value={ testimonial } />
      ) }
      { ! RichText.isEmpty( author ) && (
        <RichText.Content tagName="p" className={'author'} value={ author } />
      ) }
        </blockquote>
      </div>
    );

    const figure = (
      <div>
        { href ? (
          <a
            href={ href }
          >
            { image }
            { text }
          </a>
        ) : (
          <div>{ image }{ text }</div>
        ) }
      </div>
    );

    return (
      <div className={className}>
        <div className={"container-fluid"}>
          <div className={"row"}>
            { figure }
          </div>
        </div>
      </div>
    );
  },
};

export default Testimonial;
